<div class="flex flex-col md:flex-row items-center justify-between pt-6 gap-4" *ngIf="totalPages > 0">
    <!-- Items Per Page & Summary -->
    <div class="flex items-center gap-4 text-sm text-gray-600">
        <div class="flex items-center gap-2">
            <span>Show</span>
            <select [value]="itemsPerPage" (change)="onItemsPerPageChange($event)"
                class="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500 bg-white">
                <option *ngFor="let option of itemsPerPageOptions" [value]="option">
                    {{ option }}
                </option>
            </select>
            <span>entries</span>
        </div>
        <span class="hidden sm:inline">
            Showing {{ (currentPage - 1) * itemsPerPage + 1 }} -
            {{ Math.min(currentPage * itemsPerPage, totalItems) }} of {{ totalItems }}
        </span>
    </div>

    <!-- Pagination Controls -->
    <div class="flex items-center gap-2" *ngIf="totalPages > 1">
        <button
            class="px-3 py-1 text-sm border rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="currentPage === 1" (click)="goPrevious()">
            Previous
        </button>

        <div class="flex items-center gap-1">
            <ng-container *ngFor="let page of [].constructor(totalPages); let i = index">
                <ng-container
                    *ngIf="totalPages <= 7 || Math.abs(currentPage - (i + 1)) <= 2 || i === 0 || i === totalPages - 1">
                    <button class="w-8 h-8 flex items-center justify-center rounded-md text-sm transition-colors"
                        [ngClass]="{
                            'bg-gray-900 text-white font-medium': currentPage === i + 1,
                            'text-gray-600 hover:bg-gray-100': currentPage !== i + 1
                        }" (click)="onPageClick(i + 1)">
                        {{ i + 1 }}
                    </button>
                </ng-container>
                <span *ngIf="i === 1 && currentPage > 4 || (i === totalPages - 3 && currentPage < totalPages - 3)"
                    class="w-8 text-center text-gray-400">
                    ...
                </span>
            </ng-container>
        </div>

        <button
            class="px-3 py-1 text-sm border rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="currentPage === totalPages" (click)="goNext()">
            Next
        </button>
    </div>
</div>